import { EndpointSetting } from "@/constants/app/type";
import { EsimState } from "../types";

export const callbackEsimCatalogPublicDetail: EndpointSetting["caller"] = (
  state: EsimState,
  action,
) => {
  state.esim_catalog_public_detail.data.detail = action.payload ?? null;
};
